import React from 'react';

import styles from './radioInputField.css';

const InputField = ({ error, children }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.radios}>
                { children }
            </div>
            {error && <div className={styles['error-message']}>{error}</div>}
        </div>
    );
};

export default InputField;
